import { createContext, useContext, type ParentProps } from "solid-js"

// GigaTool: inline-code artifact filenames (e.g. `microsoft-mice-quality.md`)
// are linkified as chips, but the markdown renderer only sees the bare
// basename — it can't build a filesystem menu (Open / Show in Folder / Copy
// path) without an absolute path. The host app knows where the file was just
// written (recent write/edit tool parts), so it provides a resolver here.
// markdown.tsx asks it per basename: a hit becomes a real file:// chip (same
// affordance as an absolute-path chip in prose); a miss stays on the synthetic
// gigatool-artifact:// scheme and is resolved lazily at click time.
//
// The resolver must be synchronous and read-only (it runs inside the markdown
// decorate pass) and return an ABSOLUTE path or undefined.
export type ArtifactPathResolver = (basename: string) => string | undefined

const Context = createContext<ArtifactPathResolver>()

export function ArtifactPathsProvider(props: ParentProps<{ resolve: ArtifactPathResolver }>) {
  return <Context.Provider value={props.resolve}>{props.children}</Context.Provider>
}

export function useArtifactPaths() {
  return useContext(Context)
}
